<template>
  <el-button class="bucket-btn"
             :class="{ 'fill-with-bucket' : isFilledColors }"
             icon="mdi mdi-format-color-fill"
             @click="isFilledColors = !isFilledColors" />
</template>

<script>
export default {
  name: 'FillCropsBucketButton',
  data() {
    return {
      isFilledColors: false
    };
  },
  watch: {
    isFilledColors() {
      this.$emit('input', this.isFilledColors);
    }
  }
};
</script>

<style lang="scss">
.bucket-btn {
  position: relative;
  width: 30px;
  height: 30px;
  padding: 0;
  margin-left: 15px;
  background-color: #fff;
  border: 1.5px solid #828282;
  border-radius: 100px;

  &:hover,
  &:focus {
    background-color: #fff;
    border: 1.5px solid #828282;
  }

  i {
    position: absolute;
    top: 5px;
    right: 2px;
    font-size: 22px;
    color: #828282;
  }

  &.fill-with-bucket {
    background-color: #828282;

    i {
      color: #fff;
    }
  }

  @include breakpoint(lg-max) {
    width: 28px;
    height: 28px;
    margin-left: 0;

    i {
      top: 4px;
      right: 1px;
    }
  }
}
</style>
